export default {
    // ******************************************
    // Globals
    // ******************************************
    global_brand_name: "Rosetta Stone",
    product_name: "Rosetta Stone",

    // ******************************************
    // Globals - Locales
    // ******************************************
    locale_ar_ar_label_primary: "Arabic",
    locale_ar_ar_label_secondary: "",
    locale_de_de_label_primary: "German",
    locale_de_de_label_secondary: "",
    locale_el_gr_label_primary: "Greek",
    locale_el_gr_label_secondary: "",
    locale_en_gb_label_primary: "English",
    locale_en_gb_label_secondary: "British",
    locale_en_us_label_primary: "English",
    locale_en_us_label_secondary: "American",
    locale_es_es_label_primary: "Spanish",
    locale_es_es_label_secondary: "Spain",
    locale_es_la_label_primary: "Spanish",
    locale_es_la_label_secondary: "Latin America",
    locale_fa_ir_label_primary: "Persian",
    locale_fa_ir_label_secondary: "Farsi",
    locale_fr_fr_label_primary: "French",
    locale_fr_fr_label_secondary: "",
    locale_ga_ie_label_primary: "Irish",
    locale_ga_ie_label_secondary: "",
    locale_he_il_label_primary: "Hebrew",
    locale_he_il_label_secondary: "",
    locale_hi_in_label_primary: "Hindi",
    locale_hi_in_label_secondary: "",
    locale_it_it_label_primary: "Italian",
    locale_it_it_label_secondary: "",
    locale_ja_jp_label_primary: "Japanese",
    locale_ja_jp_label_secondary: "",
    locale_ko_kr_label_primary: "Korean",
    locale_ko_kr_label_secondary: "",
    locale_la_va_label_primary: "Latin",
    locale_la_va_label_secondary: "",
    locale_nl_nl_label_primary: "Dutch",
    locale_nl_nl_label_secondary: "",
    locale_pl_pl_label_primary: "Polish",
    locale_pl_pl_label_secondary: "",
    locale_pt_br_label_primary: "Portuguese",
    locale_pt_br_label_secondary: "Brazil",
    locale_ru_ru_label_primary: "Russian",
    locale_ru_ru_label_secondary: "",
    locale_sv_se_label_primary: "Swedish",
    locale_sv_se_label_secondary: "",
    locale_tl_ph_label_primary: "Filipino",
    locale_tl_ph_label_secondary: "Tagalog",
    locale_tr_tr_label_primary: "Turkish",
    locale_tr_tr_label_secondary: "",
    locale_vi_vn_label_primary: "Vietnamese",
    locale_vi_vn_label_secondary: "",
    locale_zn_cn_label_primary: "Chinese",
    locale_zn_cn_label_secondary: "Mandarin",

    // ******************************************
    // Nav Primary
    // ******************************************
    nav_primary_blog_label: "Blog",
    nav_primary_catalog_label: "Começar agora",
    nav_primary_catalog_select_language_label: "Selecione um idioma",
    nav_primary_contact_label: "",
    nav_primary_logo_alt: "Rosetta Stone",
    nav_primary_phone_label: "Tem perguntas? Ligue para nós:",
    nav_primary_phone_number: "1-(800)-ROSETTA",
    nav_primary_sign_in_label: "ENTRAR",
    nav_primary_support_label: "Suporte",
    nav_primary_switch_language: "English",
    nav_primary_vertical_consumer_label: "Para Você",
    nav_primary_vertical_education_for_homeschool_label: "",
    nav_primary_vertical_education_for_students_label: "",
    nav_primary_vertical_education_homeschool_label: "",
    nav_primary_vertical_education_primary_label: "Para Professores",
    nav_primary_vertical_education_secondary_label: "",
    nav_primary_vertical_education_students_label: "",
    nav_primary_vertical_enterprise_label: "Para Empresas",
    nav_primary_vertical_for_young_learners_label: "",

    // ******************************************
    // Nav Secondary - Enterprise
    // ******************************************
    nav_secondary_enterprise_blog_label: "Blog",
    nav_secondary_enterprise_custom_1_label: "Seja um Parceiro",
    nav_secondary_enterprise_home_label: "Inicial",
    nav_secondary_enterprise_label: "Empresas",
    nav_secondary_enterprise_resources_label: "Recursos",
    nav_secondary_enterprise_solutions_label: "Soluções",

    // ******************************************
    // Nav Secondary - Education Primary
    // ******************************************
    nav_secondary_education_primary_blog_label: "",
    nav_secondary_education_primary_custom_1_label: "Seja um Parceiro",
    nav_secondary_education_primary_home_label: "Inicial",
    nav_secondary_education_primary_label: "Educação Basica",
    nav_secondary_education_primary_resources_label: "Recursos",
    nav_secondary_education_primary_solutions_label: "Soluções",

    // ******************************************
    // Nav Secondary - Education Secondary
    // ******************************************
    nav_secondary_education_secondary_blog_label: "Blog",
    nav_secondary_education_secondary_custom_1_label: "Seja um Parceiro",
    nav_secondary_education_secondary_home_label: "Inicial",
    nav_secondary_education_secondary_label: "Ensino Superior",
    nav_secondary_education_secondary_resources_label: "Recursos",
    nav_secondary_education_secondary_solutions_label: "Soluções",

    // ******************************************
    // Nav Secondary - Education Homeschool
    // ******************************************
    nav_secondary_education_homeschool_blog_label: "",
    nav_secondary_education_homeschool_home_label: "",
    nav_secondary_education_homeschool_label: "",
    nav_secondary_education_homeschool_resources_label: "",
    nav_secondary_education_homeschool_solutions_label: "",

    // ******************************************
    // Nav Secondary - Services
    // ******************************************
    nav_secondary_services_blog_label: "",
    nav_secondary_services_home_label: "",
    nav_secondary_services_label: "",
    nav_secondary_services_resources_label: "",
    nav_secondary_services_solutions_label: "",

    // ******************************************
    // Shared - Awards
    // ******************************************
    awards_header_label: "Aprovado há 25+ anos pelas melhores organizações.",
    awards_bmw: "BMW",
    awards_ikea: "Ikea",
    awards_lego: "Lego",
    awards_twitter: "Twitter",
    awards_uber: "Uber",
    awards_williams_sonoma: "Williams Sonoma",

    // ******************************************
    // Shared - Branded Quotes
    // ******************************************
    branded_quotes_header_label: "O que as pessoas falam sobre nós.",
    branded_quotes_cnn_name: "CNN",
    branded_quotes_cnn_quote: "&quot;<em>A jóia da coroa</em> entre os métodos de aprendizado de idiomas.&quot;",
    branded_quotes_cnn_type: "cnn",

    branded_quotes_macworld_name: "MacWorld",
    branded_quotes_macworld_quote:
        "&quot;Eu amo o programa Rosetta Stone e acho que <em>o método deles de aprender idiomas funciona.</em>&quot;",
    branded_quotes_macworld_type: "macworld",

    branded_quotes_techcrunch_name: "TechCrunch",
    branded_quotes_techcrunch_quote:
        "&quot;Com sua excelente interface para o usuário, instruções claras e uma ampla gama de jogos e desafios ...  <em>Rosetta Stone surpreende.</em>&quot;",
    branded_quotes_techcrunch_type: "techcrunch",

    // ******************************************
    // Shared - Related Resources
    // ******************************************
    related_resources_label: "",
    related_resources_button_label: "",

    // ******************************************
    // Shared - Verticals
    // ******************************************
    verticals_label: "Que tipo de aluno você é?",
    verticals_education_primary: "Educação Basica",
    verticals_education_secondary: "Ensino Superior",
    verticals_enterprise: "Empresas",
    verticals_publicsector: "",

    // ******************************************
    // Footer
    // ******************************************
    // CTA Form
    footer_cta_email_button: "",
    footer_cta_email_main_label: "",
    footer_cta_email_placeholder: "",
    footer_cta_email_sub_label: "",
    footer_cta_form_comments: "",
    footer_cta_form_country: "",
    footer_cta_form_email: "Email",
    footer_cta_form_firstname: "Nome",
    footer_cta_form_lastname: "Sobrenome",
    footer_cta_form_organization: "Nome da Organização",
    footer_cta_form_organizationsize: "Tamanho da Organização",
    footer_cta_form_organizationsize_100: "100 ou Menos",
    footer_cta_form_organizationsize_500: "101 - 500",
    footer_cta_form_organizationsize_1000: "501 - 1,000",
    footer_cta_form_organizationsize_5000: "1,001 - 5,000",
    footer_cta_form_organizationsize_10000: "5,001 - 10,000",
    footer_cta_form_organizationsize_25000: "10,001 - 25,000",
    footer_cta_form_organizationsize_50000: "25,001 - 50,000",
    footer_cta_form_organizationsize_more: "50,001 - Mais",
    footer_cta_form_phone: "Número de Telefone (Opcional)",
    footer_cta_form_pricing_thanks: "Obrigado pelo seu interesse! Alguém entrará em contato com você em breve.",
    footer_cta_form_role: "Função (ou título)",
    footer_cta_form_role_boardmember: "Membro do Conselho",
    footer_cta_form_role_curriculumdirector: "Diretor de Currículo / Coordenador de Instrução",
    footer_cta_form_role_director: "Diretor",
    footer_cta_form_role_executive: "Gerência Geral / Executiva",
    footer_cta_form_role_individualcontributor: "Contribuidor Individual",
    footer_cta_form_role_manager: "Gerente",
    footer_cta_form_role_principal: "Diretor da Escola",
    footer_cta_form_role_superintendent: "Superintendente / Administrador Distrital",
    footer_cta_form_role_teacher: "Professor",
    footer_cta_form_role_techcoordinator: "Coordenador de Tecnologia",
    footer_cta_form_role_vicepresident: "Vice Presidente",
    footer_cta_form_submit: "Consulta de preços",
    footer_cta_how_hear_blog: "Blog",
    footer_cta_how_hear_email: "O email",
    footer_cta_how_hear_event: "Evento",
    footer_cta_how_hear_online: "Conectados",
    footer_cta_how_hear_other: "De outros",
    footer_cta_how_hear_referral: "Referência",
    footer_cta_how_hear_search: "Motor de pesquisa",
    footer_cta_how_hear_social: "Mídia social",
    footer_cta_how_hear_title: "Como você ficou sabendo sobre nós? (Opcional)",
    footer_cta_how_hear_webinar: "Webinar",
    footer_cta_opt_in_learn_more_button_text: "aqui",
    footer_cta_opt_in_learn_more_link_text_1: "aqui.",
    footer_cta_opt_in_learn_more_privacyemail: " privacyofficer@rosettastone.com",
    footer_cta_opt_in_learn_more_privacyUrl: "https://resources.rosettastone.com/CDN/br/pdfs/br_privacy_policy.pdf",
    footer_cta_opt_in_learn_more_text_1:
        "A Rosetta Stone tem o compromisso de salvaguardar a sua privacidade. A nossa Política de Privacidade completa está disponível ",
    footer_cta_opt_in_learn_more_text_2: " privacyofficer@rosettastone.com",
    footer_cta_opt_in_learn_more_text_3: ".",
    footer_cta_opt_in_text_after_button: "para maiores informações.",
    footer_cta_opt_in_text_before_button:
        "Sim! Eu gostaria de receber atualizações de produtos e marketing da Rosetta Stone. Clique",
    footer_cta_pricing_button: "CONSULTA DE PREÇOS",
    footer_cta_pricing_label: "Listo para el siguiente paso?",
    footer_cta_pricing_subtitle: "Por favor, preencha e entraremos em contato imediatamente.",
    footer_cta_pricing_title: "Receba as informações que você precisa sobre os preços.",

    // Menu
    footer_menu_about_blog_label: "Blog",
    footer_menu_about_careers_label: "Carreiras",
    footer_menu_about_contact_label: "Contato",
    footer_menu_about_label: "Sobre",
    footer_menu_products_consumer_label: "Por onde começar?",
    footer_menu_products_education_primary_label: "Para Educadores",
    footer_menu_products_education_secondary_label: "Para Educadores Superiores",
    footer_menu_products_enterprise_label: "Para Empresas",
    footer_menu_products_label: "Por onde começar?",
    footer_menu_support_label: "Suporte",
    footer_menu_support_support_site_label: "Apoio",

    // Meta
    footer_meta_agreements_label: "Acordos",
    footer_meta_ccpa_label: "Do Not Sell My Information",
    footer_meta_cookie_settings_label: "Configurações de cookies",
    footer_meta_copyright_alt: "Go to home page",
    footer_meta_copyright_IXL: "A division of IXL Learning",
    footer_meta_copyright_label: "Rosetta Stone Ltd. Todos os direitos reservados.",
    footer_meta_privacy_policy_label: "Política de Privacidade",
    footer_meta_terms_conditions_label: "Termos e Condições",

    // Region
    footer_region_label: "Mudar de região",
    footer_region_options_au_label: "Australia",
    footer_region_options_br_label: "Brasil",
    footer_region_options_cn_label: "中国",
    footer_region_options_de_label: "Deutschland",
    footer_region_options_es_label: "España",
    footer_region_options_eu_label: "Europe",
    footer_region_options_fr_label: "France",
    footer_region_options_it_label: "Italia",
    footer_region_options_jp_label: "日本",
    footer_region_options_kr_label: "대한민국",
    footer_region_options_la_label: "America Latina",
    footer_region_options_uk_label: "United Kingdom",
    footer_region_options_us_label: "United States",

    // Social
    footer_social_label: "Conecte-se conosco",
    footer_social_facebook_alt: "Facebook",
    footer_social_instagram_alt: "Instagram",
    footer_social_twitter_alt: "Twitter",
    footer_social_youtube_alt: "Youtube"
};
